import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

$(function () {

  if ($('.js-topMv-slider').length > 0) {
    new Splide(".js-topMv-slider", {
      type: "loop",
      arrows: false,
      pagination: false,
      drag: false,
      autoWidth: true,
      gap: 0,
      speed: 2000,
      autoScroll: {
        speed: 0.5,
        pauseOnHover: false,
        pauseOnFocus: false,
      },
    }).mount({ AutoScroll });
  }

  if ($('.splide.sec09-slide').length > 0) {
    new Splide(".splide.sec09-slide", {
      type: "loop",
      arrows: false,
      pagination: false,
      drag: false,
      autoWidth: true,
      gap: 10,
      autoScroll: {
        speed: 1,
      },
    }).mount({ AutoScroll });
  }

  if ($('.js-clinic-slider').length > 0) {
    new Splide('.js-clinic-slider', {
      type         : 'loop',
      perMove      : 1,
      focus        : 'center',
      updateOnMove : true,
      gap          : '24px',
      arrows       : true,
      pagination   : true,
      autoplay     : true,
      interval     : 4000,
      pauseOnHover : true,
      speed        : 600,
      fixedWidth   : 740,
      breakpoints: {
        768: {
          perPage   : 1,
          gap       : '16px',
          arrows    : true,
          pagination: true,
          fixedWidth: 360,
        },
      },
    }).mount();
  }

});

